// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__Vcp2G","tab":"Tabs_tab__TCX30","isActiveTab":"Tabs_isActiveTab__EAbSc"};